import { render, staticRenderFns } from "./NewClientPopUp.vue?vue&type=template&id=78a8d5f4&"
import script from "./NewClientPopUp.vue?vue&type=script&lang=js&"
export * from "./NewClientPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports